var LINK_EVENT_TYPE_KEYS = [
    'integrationConnected',
    'integrationConnectionError',
    'integrationMfaRequired',
    'integrationMfaEntered',
    'integrationOAuthStarted',
    'integrationAccountSelectionRequired',
    'transferCompleted',
    'integrationSelected',
    'credentialsEntered',
    'transferStarted',
    'transferPreviewed',
    'transferPreviewError',
    'transferExecutionError',
    'pageLoaded',
    'transferAssetSelected',
    'transferNetworkSelected',
    'transferAmountEntered',
    'transferMfaRequired',
    'transferMfaEntered',
    'transferKycRequired',
    'done',
    'close'
];
export function isLinkEventTypeKey(key) {
    return LINK_EVENT_TYPE_KEYS.includes(key);
}
